export default __webpack_public_path__ + "static/media/002-confectioner.f538db43.svg";